export default __webpack_public_path__ + "static/media/kibblez.acabb6e8.png";